/**
 * Helper function to get the correct URL for cloud-stored files
 * @param {string} storagePath - Storage path from database (e.g., "hallstatt/products/images/abc.jpg")
 * @returns {string} - Full URL to access the file
 */
export const getFileUrl = (storagePath) => {
  if (!storagePath) return '';
  
  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
  
  // If it's already a full URL (legacy data), return as is
  if (storagePath.startsWith('http://') || storagePath.startsWith('https://')) {
    return storagePath;
  }
  
  // New format: storage path that needs to be served through API
  return `${backendUrl}/api/files/${storagePath}`;
};
